import { createComponent } from '@helpers/admin';
import NavigationSectionComponent from '@template/blocks/NavigationSection/component';

export const Navigation = createComponent({
  label: 'Navigation',
  component: NavigationSectionComponent,
  fields: {
    branding: {
      label: 'Brand',
      type: 'image',
    },
    categories: {
      label: 'Links',
      type: 'array',
      arrayFields: {
        label: {
          label: 'Label',
          type: 'textarea',
        },
        link: {
          label: 'URL',
          type: 'text',
        },
        links: {
          label: 'Links',
          type: 'array',
          arrayFields: {
            label: {
              label: 'Label',
              type: 'textarea',
            },
            description: {
              label: 'Description',
              type: 'textarea',
            },
            url: {
              label: 'URL',
              type: 'textarea',
            },
            title: {
              label: 'Title',
              type: 'textarea',
            },
          },
        },
        featureBoxInfo: {
          label: 'CTA Box',
          type: 'object',
          objectFields: {
            label: {
              label: 'Label',
              type: 'textarea',
            },
            description: {
              label: 'Description',
              type: 'textarea',
            },
            url: {
              label: 'URL',
              type: 'textarea',
            },
            image: {
              label: 'Image',
              type: 'image',
            },
          },
        },
      },
    },
  },
});
